import { WidgetPositionContextType } from 'lib/layout/context/WidgetPositionContext';

/**
 * Helper to enable or disable the "add filter" and "add dimension" buttons.
 * @params metrics - the metrics chunks currently present in the sentence
 */
export const areAddChunkButtonsDisabled = (
    metrics: Partial<SentenceMetricT>[],
) => !metrics.find((metric) => metric.field);

export const getIsAlreadyOneListMetricSelected = (metrics: SentenceMetricT[]) =>
    metrics.some((metric) => metric.aggregation === 'list');

/**
 * Helper to remove the hidden metrics, dimensions and filters in the chunk
 * when user is not support.
 */
export const filterOnlyVisibleElement = <T extends AvailableElementT>(
    isSupportUser: boolean,
    availableElements: T[],
): T[] =>
    availableElements.filter(
        (element) => isSupportUser || element.isVisibleForBind,
    );

export const FROM_DASHBOARD_PARAM_KEY = 'from_dashboard';
const FROM_POSITION_PARAM_KEY = 'from_position';

export const getDashboardParamForExploreRoute = (slug: string | undefined) => {
    return slug ? `?${FROM_DASHBOARD_PARAM_KEY}=${slug}` : '';
};

export const getWidgetPositionParamForExploreRoute = (
    position: WidgetPositionContextType,
) => {
    const encodedURI = encodeURIComponent(
        `${position.md.y}, ${position.md.h}|${position.xs.y}, ${position.xs.h}`,
    );
    return position ? `${FROM_POSITION_PARAM_KEY}=${encodedURI}` : '';
};

export const getWidgetPositionFromSearchParams = (
    search: string,
): string | null => {
    const searchParams = new URLSearchParams(search);
    const widgetPosition = searchParams.get(FROM_POSITION_PARAM_KEY);
    return widgetPosition && decodeURIComponent(widgetPosition);
};

export const getSlugFromDashboardSearchParams = (
    search: string,
): string | null => {
    const searchParams = new URLSearchParams(search);
    const slug = searchParams.get(FROM_DASHBOARD_PARAM_KEY);
    return slug;
};

export const addFromDashboardAndWidgetPosParams = (
    search: string,
    fromDashboard: string | null,
    widgetPosition: string | null,
): string => {
    const searchParams = new URLSearchParams(search);
    if (fromDashboard)
        searchParams.set(FROM_DASHBOARD_PARAM_KEY, fromDashboard);
    if (widgetPosition)
        searchParams.set(FROM_POSITION_PARAM_KEY, widgetPosition);
    return searchParams.toString();
};

export const removeFromDashboardAndFromPositionParams = (search: string) => {
    const searchParams = new URLSearchParams(search);
    searchParams.delete(FROM_DASHBOARD_PARAM_KEY);
    searchParams.delete(FROM_POSITION_PARAM_KEY);
    return searchParams.toString();
};
